import React, { useState, useContext, useEffect } from "react";
import styles from "./style";
import { useTheme } from "@mui/material";
import UserContext from "../ContextUser/Context";
import AACargando from "../../Commons/AACargando";
import {
  Divider,
  Grid,
  Typography,
  TextField,
  Container,
  Dialog,
} from "@mui/material";
import {
  InputPassword,
  Link,
  Button,
} from "@alquiler-argentina/aa-componentes";
import isMobile from "ismobilejs";
import ModalCloseIcon from "../ModalCloseIcon";
import axios from "axios";
import SocialLogin from "../SocialLogin";
import SuccessRegister from "../SuccessRegister";
import { VerificationCode } from "../VerificationCode";
import SignUp from "../SignUp";
import UpdatePassword from "../UpdatePassword";
import Footer from "../Footer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import validator from "validator";
import * as Sentry from "@sentry/react";

export default function SignIn({
  modalOpen,
  onCloseLoginModal,
  createAnfitrion,
  esTroya,
}) {
  const theme = useTheme();
  const classes = styles(theme);

  const [showUpdatePassword, setShowUpdatePassword] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userExist, setUserExist] = useState(false);
  const [loading, setLoading] = useState(true);
  const [viewSocialLogin, setViewSocialLogin] = useState(false);
  const [dataUser, setDataUser] = useState("");
  const [incorrectPassword, setIncorrectPassword] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [successSignIn, setSuccessSignIn] = useState(false);
  const [viewVerification, setVerification] = useState(false);
  const [forgotPassword, setForgot] = useState(false);
  const { authenticate, onSetUserInfo, state, redirectIfLogged, getSession } =
    useContext(UserContext);

  const isApp = window.location.href.includes("app");
  const cookies = document.cookie.split(";");
  const cognitoCookies = cookies.filter((cookie) =>
    cookie.startsWith(" CognitoIdentityServiceProvider")
  );
  
  useEffect(() => {
    getSession();
    if (cognitoCookies && cognitoCookies.length > 0 && !modalOpen && state.email !== null) {
      redirectIfLogged(state.tipo);
    }
    if (cognitoCookies && cognitoCookies.length === 0) {
      setLoading(false);
    }
  }, [state.tipo]);

  const cleanCookiesCognito = () => {
    let fechaActual = new Date();
    fechaActual.setTime(fechaActual.getTime() - 1 * 24 * 60 * 60 * 1000);
    let expiresCookie = fechaActual.toUTCString();

    let hostName = window.location.hostname;
    let domainForCookie = hostName.replace("www", "");

    const cookies = document.cookie.split(";");

    cookies.forEach((cookie) => {
      if (cookie.startsWith(" CognitoIdentityServiceProvider") || cookie.startsWith(" UserSession")) {
        const cookieName = cookie.split("=")[0];

        document.cookie = `${cookieName}=; expires=${expiresCookie}; path=/;domain=${domainForCookie};`;
      }
    });
  };
  const verifyIfUserExist = (event) => {
    cleanCookiesCognito();
    event.preventDefault();
    if (!validator.isEmail(email)) {
      setErrorEmail(true);
      setLoading(false);
      return false;
    }
    setLoading(true);
    axios
      .get(
        `${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/?email=${email}`
      )
      .then((result) => {
        if (result.data.email) {
          const data = result.data;
          // si no actualizo clave lo envio al update password
          if (!parseInt(data.updated_password)) {
            modalOpen
              ? setShowUpdatePassword(true)
              : (window.location.href = `/update-password?email=${email}&tipo=${data.tipo}`);
            setDataUser(data);
            setLoading(false);
          } else {
            setLoading(false);
            setDataUser(data);
            onSetUserInfo({
              email: data.email,
              identity: data.identity,
              name: data.name,
              picture: data.picture,
              tipo: data.tipo,
            });
            setUserExist(true);
          }
          return;
        } else {
          setLoading(false);
          // si el usuario no existe lo mando al registrar pasandole el email como parametro
          modalOpen
            ? setShowRegister(true)
            : (window.location.href =
                (!isApp
                  ? process.env.MIX_DOMINIO_WEB
                  : process.env.MIX_DOMINIO_APP) +
                "/register?email=" +
                email);
        }
      });
    return true;
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    authenticate(email, password)
      .then(() => {
        if (dataUser.tipo != 1 || createAnfitrion) {
          setSuccessSignIn(true);
          setLoading(false);
        } else {
          modalOpen ? location.reload() : setSuccessSignIn(true);
        }
      })
      .catch((err) => {
        Sentry.captureException(
          err,
          "Something is wrong SingIn, function onSubmit"
        );
        if (err.name == "NotAuthorizedException") {
          setLoading(false);
          setIncorrectPassword(true);
          setPassword("");
        }
        if (err.name == "PasswordResetRequiredException") {
          setLoading(false);
          modalOpen ? (
            <UpdatePassword
              createAnfitrion={createAnfitrion ? true : false}
              esTroya={esTroya ? true : false}
              modalOpen={modalOpen}
              tipo={dataUser.tipo}
            />
          ) : (
            (window.location.href = `/update-password?email=${email}`)
          );
        }
        if (err.name == "UserNotConfirmedException") {
          setLoading(false);
          setVerification(true);
        }
      });
  };
  const noVerified = dataUser.verified == '0';
  const onForgotPassword = () =>{
    if(noVerified){
      setVerification(true);
    } else {
    setShowUpdatePassword(true);
    }
    setLoading(false);
    setForgot(true);
  }

  const signInFacebook = () => {
    const urlLoginFacebook = `${
      process.env.MIX_DOMAIN_COGNITO
    }/oauth2/authorize?identity_provider=Facebook&redirect_uri=${
      !isApp ? process.env.MIX_DOMINIO_WEB : process.env.MIX_DOMINIO_APP
    }/success-register&response_type=code&client_id=${
      process.env.MIX_CLIENT_ID_COGNITO
    }&skip_api_login=1&api_key=348110967079868&kid_directed_site=0&scope=email+openid+profile+aws.cognito.signin.user.admin&app_id=348110967079868&signed_next=1&display=page&locale=es_LA`;
    if (modalOpen) {
      window.open(
        urlLoginFacebook,
        "_blank",
        "location=yes , height=570 ,width=520, scrollbars=yes, status=yes"
      );
    } else {
      window.open(urlLoginFacebook, "_self");
    }
  };

  const signInGoogle = () => {
    const urlLoginGoogle = `${
      process.env.MIX_DOMAIN_COGNITO
    }/oauth2/authorize?identity_provider=Google&redirect_uri=${
      !isApp ? process.env.MIX_DOMINIO_WEB : process.env.MIX_DOMINIO_APP
    }/success-register&response_type=code&client_id=${
      process.env.MIX_CLIENT_ID_COGNITO
    }&scope=email+openid+profile+aws.cognito.signin.user.admin`;
    if (modalOpen) {
      window.open(
        urlLoginGoogle,
        "_blank",
        "location=yes , height=570 ,width=520, scrollbars=yes, status=yes"
      );
    } else {
      window.open(urlLoginGoogle, "_self");
    }
  };

  const handleBack = () => {
    setUserExist(false);
  };

  if (viewSocialLogin) {
    return (
      <SocialLogin
        onCloseLoginModal={onCloseLoginModal}
        setViewSocialLogin={setViewSocialLogin}
        modalOpen={modalOpen}
        email={dataUser.email}
        picture={dataUser.picture}
        name={dataUser.name}
        identity={dataUser.identity}
      />
    );
  }
  if (successSignIn) {
    return (
      <SuccessRegister
        esTroya={esTroya}
        createAnfitrion={createAnfitrion}
        email={dataUser.email}
        onCloseLoginModal={onCloseLoginModal}
        anfitrion
        tipo={dataUser.tipo}
        modalOpen={modalOpen}
      />
    );
  }

  if (loading && !modalOpen) {
    return (
      <div css={classes.aaLoader}>
        <AACargando />
      </div>
    );
  }

  if (showRegister) {
    return (
      <SignUp
        esTroya={esTroya ? true : false}
        createAnfitrion={createAnfitrion ? true : false}
        onCloseLoginModal={onCloseLoginModal}
        modalOpen={modalOpen}
        userEmail={email}
      />
    );
  }
  if (showUpdatePassword) {
    return (
      <UpdatePassword
        createAnfitrion={createAnfitrion ? true : false}
        esTroya={esTroya ? true : false}
        forgotPassword={forgotPassword ? true : false}
        onCloseLoginModal={onCloseLoginModal}
        modalOpen={modalOpen}
        userEmail={email}
        tipo={dataUser.tipo}
      />
    );
  }

  const signInContainer = (
    <Container css={classes.container} component="main" maxWidth="xs">
      {loading ? (
        <div css={classes.aaLoaderModal}>
          <AACargando />
        </div>
      ) : null}
      {modalOpen && <ModalCloseIcon onClick={onCloseLoginModal} />}
      <div>
        {viewVerification ? (
          <VerificationCode
            resendCode
            onCloseLoginModal={onCloseLoginModal}
            modalOpen={modalOpen}
            password={password}
            title="Verificar dirección de correo electrónico"
            subtitle="El correo electrónico aún no ha sido verificado, te enviamos nuevamente el código de verificación a "
            email={email}
            createAnfitrion={createAnfitrion ? true : false}
            esTroya={esTroya ? true : false}
            forgotPassword={forgotPassword ? true : false}
            tipo={dataUser.tipo}
          />
        ) : (
          <div style={loading ? { display: "none" } : null}>
            <div css={classes.paper}>
              {userExist ? (
                <div css={!modalOpen ? classes.containerIcon : ""}>
                  <IconButton
                    css={modalOpen ? classes.backIcon : ""}
                    onClick={handleBack}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                </div>
              ) : null}
              <Grid item xs={12}>
                <img src="https://img.alqastatic.com/_img_/isologo.png?w=48" alt="Logo AA" />
              </Grid>
              <Typography variant="h5" css={classes.titulo} component="div">
                {userExist
                  ? "Inicia sesión"
                  : "Inicia sesión o crea una cuenta"}
              </Typography>
              <form
                css={classes.form}
                noValidate
                onSubmit={userExist ? onSubmit : verifyIfUserExist}
              >
                {userExist ? (
                  <Grid>
                    <Typography>Ingresa la contraseña de</Typography>
                    <Typography
                      style={{ fontWeight: "700", marginBottom: "20px" }}
                    >
                      {email}
                    </Typography>
                    <InputPassword
                      error={incorrectPassword ? true : false}
                      helperText={
                        incorrectPassword
                          ? "Contraseña incorrecta, intente nuevamente"
                          : ""
                      }
                      fullWidth
                      label="Contraseña"
                      id="password"
                      name="password"
                      onChange={(event) => {
                        setPassword(event.target.value);
                      }}
                      value={password}
                      variant="outlined"
                    />
                  </Grid>
                ) : (
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Correo electrónico"
                    type="email"
                    name="email"
                    error={errorEmail ? true : false}
                    helperText={errorEmail ? "Correo electrónico inválido" : ""}
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                )}
                <Button
                  size="large"
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  css={classes.submit}
                >
                  Continuar
                </Button>
                {userExist && (
                  <Grid
                    container
                    alignItems="center"
                    spacing={3}
                    justifyContent="flex-end"
                  >
                    <Grid item flexDirection="column">
                      {modalOpen ? (
                        <Link
                          onClick={onForgotPassword}
                          component="button"
                        >
                          ¿Olvidaste la contraseña?
                        </Link>
                      ) : (
                        <Link href="/update-password?forgot=true">
                          ¿Olvidaste la contraseña?
                        </Link>
                      )}
                    </Grid>
                  </Grid>
                )}
              </form>
            </div>
            <Divider css={classes.divider}>o</Divider>
            <Grid container direction="column">
              {!isApp ? (
                <Grid item>
                  <Button
                    css={classes.buttonOutlined}
                    style={{ marginBottom: "16px" }}
                    fullWidth
                    variant="outlined"
                    color="inherit"
                    startIcon={<img src="/imagenes/facebookIconColor.png" />}
                    size="large"
                    onClick={signInFacebook}
                  >
                    <Typography style={{ textTransform: "none" }}>
                      Ingresar con Facebook
                    </Typography>
                  </Button>
                </Grid>
              ) : null}
              <Grid item>
                <Button
                  css={classes.buttonOutlined}
                  fullWidth
                  variant="outlined"
                  color="inherit"
                  size="large"
                  startIcon={<img src="/imagenes/googleIconColor.png" />}
                  onClick={signInGoogle}
                >
                  <Typography style={{ textTransform: "none" }}>
                    Ingresar con Google
                  </Typography>
                </Button>
              </Grid>
            </Grid>
            {userExist ? (
              <Grid
                container
                css={classes.helpLink}
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item>
                  <Typography>¿Necesitás ayuda?</Typography>
                </Grid>
                <Grid item>
                  <Link href="https://api.whatsapp.com/send?phone=5491152638215">
                    Escribir por Whatsapp
                  </Link>
                </Grid>
              </Grid>
            ) : null}
            <Footer />
          </div>
        )}
      </div>
    </Container>
  );

  return modalOpen ? (
    <Dialog
      onClose={onCloseLoginModal}
      fullScreen={isMobile.any}
      css={isMobile.any ? classes.modal : ""}
      scroll="body"
      open={cognitoCookies.length !== 0 ? false : modalOpen}
    >
      {signInContainer}
    </Dialog>
  ) : (
    signInContainer
  );
}
